import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Button, Box, Paper, Grid, Slider,
    TextField, IconButton, Autocomplete
} from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { getTrabajadores, getUsuariosCliente, putTiempoTrabajadoTarea } from '../../../services/apis';
import { Delete } from '@mui/icons-material';
import { ordenarOpcionesPorLabel, textoMayusculas } from '../../../utils/utils';

const formatHoras = (value) => {
    const h = Math.floor(value);
    const m = Math.round((value - h) * 60);
    return `${h}h${m > 0 ? ` ${m}min` : ''}`;
};

const obtenerFechaCompleta = (diaTexto) => {
    const match = diaTexto.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
    if (!match) return diaTexto;
    const dia = parseInt(match[1], 10);
    const mes = parseInt(match[2], 10) - 1;
    const hoy = new Date();
    const fecha = new Date(hoy.getFullYear(), mes, dia);
    const diasLargos = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const mesesLargos = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    return `${diasLargos[fecha.getDay()]} ${fecha.getDate()} de ${mesesLargos[fecha.getMonth()]}`;
};

const generarCodigoDia = (fecha) => {
    const dias = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];
    const dia = dias[fecha.getDay()];
    return `${dia}${fecha.getDate()}/${fecha.getMonth() + 1}`;
};

const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const FormEditarTiempoTarea = ({ data, open, setOpen, initialDate, id_tarea, cargarTareas, setPausarRecargaTareas }) => {
    const [diasEditados, setDiasEditados] = useState([]);
    const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
    const [usuarioSelec, setUsuarioSelec] = useState(null);
    const [opUsuarios, setOpUsuarios] = useState([]);
    const [tareasEliminadas, setTareasEliminadas] = useState([]);

    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores();
            const tmp = [...response.data];
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item, index) => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })))
            setOpUsuarios(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    useEffect(() => {

        cargarTrabajadores();
    }, []);

    useEffect(() => {
        if (!setPausarRecargaTareas) return;

        setPausarRecargaTareas(open);

        return () => setPausarRecargaTareas(false);
    }, [open, setPausarRecargaTareas]);

    useEffect(() => {
        const nuevosDias = data.map(d => ({
            dia: d.dia,
            fechaCompleta: obtenerFechaCompleta(d.dia),
            tareas: d.tareas.map((t, idx) => ({
                ...t,
                localId: `${t.usuario}-${t.id ?? idx}`
            }))
        }));
        setDiasEditados(nuevosDias);

        if (initialDate) {
            setFechaSeleccionada(new Date(initialDate));
        } else {
            const primerDia = nuevosDias[0];
            const match = primerDia.dia.match(/[A-Z](\d{1,2})\/(\d{1,2})/);
            if (match) {
                const dia = parseInt(match[1], 10);
                const mes = parseInt(match[2], 10) - 1;
                const hoy = new Date();
                setFechaSeleccionada(new Date(hoy.getFullYear(), mes, dia));
            }
        }

    }, [data, initialDate]);

    const handleClose = () => setOpen(false);

    const handleNavegarDia = (direccion) => {
        const nuevaFecha = new Date(fechaSeleccionada);
        nuevaFecha.setDate(nuevaFecha.getDate() + direccion);
        setFechaSeleccionada(nuevaFecha);
    };

    if (!fechaSeleccionada) return null;

    const fechaFormateada = formatDateLocal(fechaSeleccionada);
    const diaCodigo = generarCodigoDia(fechaSeleccionada);
    const fechaCompleta = obtenerFechaCompleta(diaCodigo);

    const tareasDia = diasEditados.find(d => d.dia === diaCodigo)?.tareas || [];

    const handleChangeHoras = (localId, newHoras) => {
        setDiasEditados(prev => prev.map(dia =>
            dia.dia === diaCodigo ? {
                ...dia,
                tareas: dia.tareas.map(t =>
                    t.localId === localId ? { ...t, horas: newHoras } : t
                )
            } : dia
        ));
    };

    const handleAgregarTarea = () => {
        if (!usuarioSelec) return;

        const nuevaTarea = {
            usuario: usuarioSelec.label,
            horas: 0.5,
            localId: `${usuarioSelec.label}-new-${Date.now()}`
        };

        const existe = diasEditados.find(d => d.dia === diaCodigo);
        if (existe) {
            setDiasEditados(prev => prev.map(dia =>
                dia.dia === diaCodigo ? {
                    ...dia,
                    tareas: [...dia.tareas, nuevaTarea]
                } : dia
            ));
        } else {
            setDiasEditados(prev => [
                ...prev,
                {
                    dia: diaCodigo,
                    fechaCompleta,
                    tareas: [nuevaTarea]
                }
            ]);
        }

        setUsuarioSelec(null);
    };

    const handleGuardar = (e) => {
        actualizarTiempoTrabajadoTarea();
    }


    const actualizarTiempoTrabajadoTarea = async () => {
        try {
            const token = localStorage.getItem('token'); // Ajusta según tu implementación
            const payload = prepararPayloadTiempoTarea(diasEditados, token, id_tarea, tareasEliminadas);

            const response = await putTiempoTrabajadoTarea(payload);
            if (response.success == true) {
                cargarTareas();
                handleClose();
            }
            console.log('Guardado exitoso:', response);
        } catch (error) {
            console.error('Error al guardar tareas:', error);
        }
    };

    const prepararPayloadTiempoTarea = (diasEditados, token, id_tarea, eliminados) => {
        return {
            token,
            id_tarea,
            eliminados,
            data: diasEditados.map(d => ({
                dia: d.dia,
                tareas: d.tareas.map(t => {
                    const usuarioObj = opUsuarios.find(u => u.label === t.usuario);
                    return {
                        id: t.id ?? null,
                        id_usuario: usuarioObj?.value ?? null, // ← buscamos el ID desde el nombre
                        usuario: t.usuario,
                        horas: t.horas
                    };
                })
            }))
        };
    };
    const handleEliminarTarea = (localId) => {
        setDiasEditados(prev => prev.map(dia =>
            dia.dia === diaCodigo
                ? {
                    ...dia,
                    tareas: dia.tareas.filter(t => {
                        if (t.localId === localId && t.id) {
                            setTareasEliminadas(prev => [...prev, t.id]);
                        }
                        return t.localId !== localId;
                    })
                }
                : dia
        ));
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <IconButton onClick={() => handleNavegarDia(-1)}><ArrowBack /></IconButton>
                    <TextField
                        type="date"
                        value={fechaFormateada}
                        onChange={(e) => setFechaSeleccionada(new Date(e.target.value))}
                        size="small"
                    />
                    <IconButton onClick={() => handleNavegarDia(1)}><ArrowForward /></IconButton>
                </Box>
                <Box mt={2}>
                    <Autocomplete
                        fullWidth
                        options={opUsuarios}
                        value={usuarioSelec}
                        onChange={(e, newValue) => setUsuarioSelec(newValue)}
                        renderInput={(params) => (
                            <TextField {...params} label="Seleccionar empleado" size="small" />
                        )}
                    />
                </Box>
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleAgregarTarea}
                    // disabled={!usuarioSelec}
                    >
                        Agregar tarea
                    </Button>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="h6" gutterBottom>
                    {fechaCompleta} ({diaCodigo})
                </Typography>
                <Grid container spacing={2}>
                    {tareasDia.map(tarea => (
                        <Grid item xs={12} key={tarea.localId}>
                            <Paper elevation={1} sx={{ p: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    <strong>{tarea.usuario}</strong> {tarea.id && `(ID: ${tarea.id})`}
                                </Typography>
                                <Box display="flex" alignItems="center" gap={2}>
                                    <Slider
                                        min={0}
                                        max={8}
                                        step={0.25}
                                        value={tarea.horas}
                                        onChange={(_, val) => handleChangeHoras(tarea.localId, val)}
                                        valueLabelDisplay="auto"
                                        valueLabelFormat={formatHoras}
                                        sx={{ flexGrow: 1 }}
                                    // disabled={!tarea.edi}
                                    />
                                    <Typography variant="body2" sx={{ minWidth: 60 }}>
                                        {formatHoras(tarea.horas)}
                                    </Typography>
                                    <IconButton onClick={() => handleEliminarTarea(tarea.localId)} color="error"
                                    //    disabled={!tarea.edi}
                                    >
                                        <Delete />
                                    </IconButton>
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                <Button onClick={handleGuardar} variant="contained">Guardar cambios</Button>
            </DialogActions>
        </Dialog>
    );
};
